import "./style.css";

function DashboardHeading({ children }) {
    return <h1 className="dashboard-heading">{children}</h1>
}

export default DashboardHeading;